import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 8v13","key":"svg-0"}],["path",{"d":"M15 18l-3 3l-3 -3","key":"svg-1"}],["path",{"d":"M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z","key":"svg-2"}]]

const IconArrowDownRhombus = createReactComponent('outline', 'arrow-down-rhombus', 'ArrowDownRhombus', __iconNode);

export default IconArrowDownRhombus;